import { Component, OnDestroy, OnInit } from '@angular/core';
import { CreateWorkLogModal } from '../../../work-logs/modals/create-work-log/create-work-log.modal';
import { ModalService } from '@kaiser-software/chassis-core';

@Component({
    selector: 'app-security-guard-dashboard',
    templateUrl: './security-guard.component.html',
    styleUrls: ['./security-guard.component.scss'],
})
export class SecurityGuardComponent implements OnInit, OnDestroy {

    constructor(
        protected modalService: ModalService,
    ) {
        //
    }

    public ngOnInit(): void {
        //
    }

    public ngOnDestroy(): void {
        //
    }

    public openCreateWorkLogModal(): void {
        this.modalService.open(CreateWorkLogModal);
    }


}



// WEBPACK FOOTER //
// ./apps/eyewatch/src/app/eyewatch/dashboards/pages/security-guard/security-guard.component.ts